import { guyabanoColor } from 'utils/uiConstants';

export const boxNavStyle = {
  position: 'sticky',
  top: '104px',
  zIndex: 10,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: guyabanoColor,
  padding: '40px 0 30px 0',
};
